var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868D",
  d: "M10 .999c-2.365 0-4.282 1.88-4.282 4.2S7.635 9.4 10 9.4c2.364 0 4.281-1.88 4.281-4.2S12.365 1 10 1M10 10.6c-3.945 0-7.267 2.616-8.26 6.177C1.404 17.974 1.95 19 3.685 19h12.627c1.727 0 2.281-1.026 1.947-2.223-.993-3.56-4.315-6.177-8.26-6.177"
})));
export default SvgIconUser;